var _path, _path2, _g, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThankYouIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 956,
    height: 956,
    viewBox: "0 0 956 956",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M432.14 26.4774C460.518 10.0931 495.482 10.0931 523.86 26.4775L846.1 212.523C874.478 228.907 891.96 259.186 891.96 291.955V664.045C891.96 696.814 874.478 727.093 846.1 743.477L523.86 929.523C495.482 945.907 460.518 945.907 432.14 929.523L109.9 743.477C81.5217 727.093 64.0399 696.814 64.0399 664.045V291.955C64.0399 259.186 81.5217 228.907 109.9 212.523L432.14 26.4774Z",
    fill: "url(#paint0_linear_1_4553)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M432.14 26.4774C460.518 10.0931 495.482 10.0931 523.86 26.4775L846.1 212.523C874.478 228.907 891.96 259.186 891.96 291.955V664.045C891.96 696.814 874.478 727.093 846.1 743.477L523.86 929.523C495.482 945.907 460.518 945.907 432.14 929.523L109.9 743.477C81.5217 727.093 64.0399 696.814 64.0399 664.045V291.955C64.0399 259.186 81.5217 228.907 109.9 212.523L432.14 26.4774Z",
    fill: "black",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_4553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.95 73.6384C460.328 57.2541 495.292 57.254 523.67 73.6383L805.066 236.102C833.444 252.486 850.926 282.766 850.926 315.534V640.462C850.926 673.231 833.444 703.51 805.066 719.894L523.67 882.358C495.292 898.742 460.328 898.742 431.95 882.358L150.554 719.894C122.176 703.51 104.694 673.231 104.694 640.462V315.535C104.694 282.766 122.176 252.486 150.554 236.102L431.95 73.6384Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M443.065 467.196C440.2 464.331 436.315 462.722 432.264 462.722C428.212 462.722 424.327 464.331 421.462 467.196C418.598 470.06 416.988 473.946 416.988 477.997C416.988 482.048 418.598 485.934 421.462 488.798L467.102 534.438C468.523 535.848 470.209 536.964 472.063 537.721C473.916 538.478 475.901 538.861 477.903 538.85C479.986 538.784 482.033 538.291 483.917 537.401C485.801 536.511 487.483 535.244 488.857 533.677L595.349 411.972C597.808 408.919 598.994 405.035 598.659 401.129C598.324 397.224 596.494 393.598 593.551 391.008C590.608 388.419 586.78 387.065 582.863 387.229C578.947 387.394 575.245 389.063 572.529 391.89L477.903 501.425L443.065 467.196Z",
    fill: "url(#paint1_linear_1_4553)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M443.065 467.196C440.2 464.331 436.315 462.722 432.264 462.722C428.212 462.722 424.327 464.331 421.462 467.196C418.598 470.06 416.988 473.946 416.988 477.997C416.988 482.048 418.598 485.934 421.462 488.798L467.102 534.438C468.523 535.848 470.209 536.964 472.063 537.721C473.916 538.478 475.901 538.861 477.903 538.85C479.986 538.784 482.033 538.291 483.917 537.401C485.801 536.511 487.483 535.244 488.857 533.677L595.349 411.972C597.808 408.919 598.994 405.035 598.659 401.129C598.324 397.224 596.494 393.598 593.551 391.008C590.608 388.419 586.78 387.065 582.863 387.229C578.947 387.394 575.245 389.063 572.529 391.89L477.903 501.425L443.065 467.196Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M614.829 462.781C610.794 462.781 606.924 464.384 604.071 467.237C601.218 470.09 599.615 473.96 599.615 477.995C599.615 510.273 586.793 541.229 563.969 564.053C541.144 586.878 510.188 599.7 477.91 599.7C453.874 599.689 430.38 592.561 410.39 579.216C390.4 565.871 374.809 546.905 365.583 524.711C356.357 502.517 353.909 478.087 358.549 454.504C363.188 430.92 374.706 409.238 391.651 392.192C402.92 380.773 416.353 371.716 431.164 365.551C445.975 359.386 461.867 356.238 477.91 356.289C487.638 356.35 497.33 357.472 506.815 359.636C508.8 360.25 510.889 360.451 512.955 360.226C515.02 360.002 517.018 359.357 518.824 358.33C520.631 357.304 522.208 355.919 523.459 354.26C524.709 352.601 525.607 350.703 526.096 348.684C526.585 346.665 526.656 344.567 526.303 342.52C525.95 340.472 525.182 338.519 524.045 336.78C522.909 335.041 521.428 333.553 519.694 332.408C517.961 331.263 516.011 330.485 513.965 330.122C502.147 327.342 490.051 325.913 477.91 325.863C447.854 326.019 418.517 335.075 393.603 351.887C368.689 368.7 349.312 392.516 337.92 420.33C326.528 448.143 323.629 478.708 329.591 508.168C335.553 537.627 350.107 564.66 371.418 585.856C399.664 614.115 437.955 630.033 477.91 630.126C518.258 630.126 556.953 614.098 585.483 585.568C614.014 557.038 630.042 518.342 630.042 477.995C630.042 473.96 628.439 470.09 625.586 467.237C622.733 464.384 618.863 462.781 614.829 462.781Z",
    fill: "url(#paint2_linear_1_4553)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M614.829 462.781C610.794 462.781 606.924 464.384 604.071 467.237C601.218 470.09 599.615 473.96 599.615 477.995C599.615 510.273 586.793 541.229 563.969 564.053C541.144 586.878 510.188 599.7 477.91 599.7C453.874 599.689 430.38 592.561 410.39 579.216C390.4 565.871 374.809 546.905 365.583 524.711C356.357 502.517 353.909 478.087 358.549 454.504C363.188 430.92 374.706 409.238 391.651 392.192C402.92 380.773 416.353 371.716 431.164 365.551C445.975 359.386 461.867 356.238 477.91 356.289C487.638 356.35 497.33 357.472 506.815 359.636C508.8 360.25 510.889 360.451 512.955 360.226C515.02 360.002 517.018 359.357 518.824 358.33C520.631 357.304 522.208 355.919 523.459 354.26C524.709 352.601 525.607 350.703 526.096 348.684C526.585 346.665 526.656 344.567 526.303 342.52C525.95 340.472 525.182 338.519 524.045 336.78C522.909 335.041 521.428 333.553 519.694 332.408C517.961 331.263 516.011 330.485 513.965 330.122C502.147 327.342 490.051 325.913 477.91 325.863C447.854 326.019 418.517 335.075 393.603 351.887C368.689 368.7 349.312 392.516 337.92 420.33C326.528 448.143 323.629 478.708 329.591 508.168C335.553 537.627 350.107 564.66 371.418 585.856C399.664 614.115 437.955 630.033 477.91 630.126C518.258 630.126 556.953 614.098 585.483 585.568C614.014 557.038 630.042 518.342 630.042 477.995C630.042 473.96 628.439 470.09 625.586 467.237C622.733 464.384 618.863 462.781 614.829 462.781Z",
    fill: "black",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_4553",
    x: 86.3492,
    y: 61.3501,
    width: 782.921,
    height: 869.985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18.3441
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.17206
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4553"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4553",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4553",
    x1: 478,
    y1: 0,
    x2: 478,
    y2: 956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E30020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_4553",
    x1: 507.851,
    y1: 387.216,
    x2: 507.851,
    y2: 538.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E30020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_4553",
    x1: 478.305,
    y1: 325.863,
    x2: 478.305,
    y2: 630.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E30020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30020"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankYouIcon);
export default __webpack_public_path__ + "static/media/thank-you-icon.dddf87216002cf64e3e028899816c488.svg";
export { ForwardRef as ReactComponent };